import React, { FC, useContext } from 'react'

import WatchIcon from '../../../public/static/icons/watch.svg'
import ReadIcon from '../../../public/static/icons/read.svg'
import SparcleIcon from '../../../public/static/icons/sparcle.svg'

import css from './JournalBlock.module.scss'
import cx from 'classnames'

import Link from 'next/link'
import { LookBookDetailContext } from '../../../contexts/lookbookDetailProvider'

const JournalBlock: FC = () => {
  const { itemData } = useContext(LookBookDetailContext)

  if (!itemData.journal?.postLink && !itemData.journal?.videoLink) {
    return null
  }

  return (
    <div className={css.outer}>
      <div className={css.wrapper}>
        <div className={css.journal}>Журнал</div>
        <div className={css.heading}>{itemData.journal.name}</div>
        {itemData.journal.postLink && itemData.journal.videoLink ? (
          <div className={css.links}>
            <a
              className={css.link}
              target="_blank"
              rel="noreferrer"
              href={itemData.journal.videoLink}
            >
              смотреть
              <div className={cx(css.icon, css.watch_icon)}>
                <WatchIcon />
              </div>
            </a>
            <div className={css.or}>или</div>
            <Link href={itemData.journal.postLink} passHref>
              <a className={css.link} href={itemData.journal.postLink}>
                <div className={cx(css.icon, css.read_icon)}>
                  <ReadIcon />
                </div>
                читать
              </a>
            </Link>
          </div>
        ) : (
          <div className={css.link_wrapper}>
            {itemData.journal.videoLink && (
              <a
                className={css.link}
                target="_blank"
                rel="noreferrer"
                href={itemData.journal.videoLink}
              >
                <div className={cx(css.icon, css.watch_icon)}>
                  <WatchIcon />
                </div>
                смотреть
              </a>
            )}
            {itemData.journal.postLink && (
              <Link href={itemData.journal.postLink} passHref>
                <a className={css.link} href={itemData.journal.postLink}>
                  <div className={cx(css.icon, css.read_icon)}>
                    <ReadIcon />
                  </div>
                  читать
                </a>
              </Link>
            )}
          </div>
        )}

        <div className={css.sparcle}>
          <SparcleIcon />
        </div>
      </div>
    </div>
  )
}

export default JournalBlock
